import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
export class ClipboardLoader extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      Clipboard: ClipboardLoader.Clipboard
    });
  }

  async UNSAFE_componentWillMount() {
    if (!this.state.Clipboard) {
      const [mediaClient, clipboardModule] = await Promise.all([import(
      /* webpackChunkName: "@atlaskit-internal_media-client" */
      '@atlaskit/media-client'), import(
      /* webpackChunkName: "@atlaskit-internal_media-clipboard" */
      './clipboard')]);
      ClipboardLoader.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard, this.props.featureFlags);
      this.setState({
        Clipboard: ClipboardLoader.Clipboard
      });
    }
  }

  render() {
    if (!this.state.Clipboard) {
      return null;
    }

    return /*#__PURE__*/React.createElement(this.state.Clipboard, this.props);
  }

}

_defineProperty(ClipboardLoader, "displayName", 'AsyncClipboard');